import { useEffect, useRef, useState } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import "./ordensServicoCadastro.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getUnidades } from "../../services/api_unidades";
import {getOrdemById, postOrdem, updateOrdem} from "../../services/api_cadastro_ordens_servico";
import { getTipoManutencao } from "../../services/api_tipos_manutencao";
import { getPessoas } from "../../services/api_pessoas";
import { getPlanosManutencao } from "../../services/api_planos_manutencao";
import Preview from "../../components/Preview/Preview";
import { getUnidadesById } from "../../services/api_cadastros_unidades";
import { getApplicationsById } from "../../services/api_cadastros_aplicacoes";
import getDate from "../../hooks/GetDate";
import { getEmpresas } from "../../services/api_base";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const OrdensServicoRegister = (props) => {
  const location = useLocation();
  const idOrdem = location.state?.idOrdem;
  const idUnidade = location.state?.idUnidade;
  const dadosSolicitacao = location.state?.dadosSolicitacao;
  const [solicitacaoOrdem, setSolicitacaoOrdem] = useState("");
  const [anexo, setAnexo] = useState("");
  const [anexoAnterior, setAnexoAnterior] = useState("");
  const [id_aplicacao, setIdAplicacao] = useState("");
  const [id_empresa, setIdEmpresa] = useState("");
  const [id_unidade, setIdUnidade] = useState("");
  const [id_tipo_manutencao, setIdTipoManutencao] = useState("");
  const [id_plano_manutencao, setIdPlanoManutencao] = useState("");
  const [id_solicitacao_servico, setIdSolicitacaoServico] = useState("");
  const [id_pessoa, setIdPessoa] = useState("");
  const [solicitante, setSolicitante] = useState("");
  const [previsao_inicio, setPrevisaoInicio] = useState("");
  const [previsao_termino, setPrevisaoTermino] = useState("");
  const [empresasListagem, setEmpresasListagem] = useState([]);
  const [unidadesListagem, setUnidadesListagem] = useState([]);
  const [unidadesBackup, setUnidadesBackup] = useState([]);
  const [aplicacoesListagem, setAplicacoesListagem] = useState([]);
  const [tiposManutencaoListagem, setTiposManutencaoListagem] = useState([]);
  const [planosManutencaoListagem, setPlanosManutencaoListagem] = useState([]);
  const [pessoasListagem, setPessoasListagem] = useState([]);
  const [informacoesSistema, setInformacoesSistema] = useState("");
  const [dataHoraFechamento, setDataHoraFechamento] = useState("");
  const [dataHoraCancelamento, setDataHoraCancelamento] = useState("");
  const [situacao, setSituacao] = useState("");
  const [id_user_gerou, setIdUserGerou] = useState("");
  const [id_user_fechou, setIdUserFechou] = useState("");
  const [id_user_cancelou, setIdUserCancelou] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const inputRefs = {
    Empresa: useRef(null),
    Unidade: useRef(null),
    tipoManutencao: useRef(null),
    Aplicacao: useRef(null),
    Anexo: useRef(null),
    planosManutencao: useRef(null),
    Solicitante: useRef(null),
    Solicitacao: useRef(null),
    previsaoInicio: useRef(null),
    previsaoTermino: useRef(null),
  };

  const fetchDadosSolicitacao = async () => {
    setIdSolicitacaoServico(dadosSolicitacao.id || "");
    setSolicitacaoOrdem(dadosSolicitacao.solicitacao || "");
    setIdUnidade(dadosSolicitacao.id_unidade || "");
    handleAplicacoesUnidade(dadosSolicitacao.id_unidade);
    setIdAplicacao(dadosSolicitacao.id_aplicacao || "");
    handleAplicacao(dadosSolicitacao.id_aplicacao);
    setIdPessoa(dadosSolicitacao.user.pessoa?.id || "");
    setSolicitante(dadosSolicitacao.user.pessoa?.nome || "");
    setAnexo(dadosSolicitacao.anexo || "");
    setIdEmpresa(dadosSolicitacao.id_empresa || "");
  };

  const fetchOrdem = async () => {
    try {
      const response = await getOrdemById(idOrdem);
      const ordemDados = response.data.OrdensServico;
      setSolicitacaoOrdem(ordemDados.solicitacao || "");
      setAnexoAnterior(ordemDados.anexo || "");
      setAnexo(ordemDados.anexo || "");
      setIdAplicacao(ordemDados.id_aplicacao || "");
      setIdEmpresa(ordemDados.unidade.id_empresa);
      setIdUnidade(ordemDados.id_unidade || "");
      setIdTipoManutencao(ordemDados.id_tipo_manutencao || "");
      setDataHoraFechamento(ordemDados.data_hora_fechamento || "");
      setDataHoraCancelamento(ordemDados.data_hora_cancelamento || "");
      setSituacao(ordemDados.situacao || "");
      setIdUserGerou(ordemDados.id_user_gerou || "");
      setIdUserFechou(ordemDados.id_user_fechou || "");
      setIdUserCancelou(ordemDados.id_user_cancelou || "");
      setIdPessoa(ordemDados.id_pessoa || "");
      setPrevisaoInicio(ordemDados.previsao_inicio || "");
      setPrevisaoTermino(ordemDados.previsao_termino || "");
      setIdPlanoManutencao(ordemDados.id_plano_manutencao || "");
    } catch (error) {
      console.error("Erro ao obter os dados da ordem de serviço:", error);
    }
  };

  const fetchEmpresas = async () => {
    try {
      const response = await getEmpresas();
      if (response) {
        const empresasAtivas = response.data.empresas.filter(
          (empresa) => empresa.deleted_at == null
        );
        setEmpresasListagem(empresasAtivas);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter empresas:", error);
    }
  };

  const fetchUnidades = async () => {
    try {
      const response = await getUnidades();
      if (response) {
        const unidadesAtivas = response.data.unidades.filter(
          (unidade) => unidade.deleted_at == null
        );
        setUnidadesListagem(unidadesAtivas);
        setUnidadesBackup(unidadesAtivas);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter empresas e unidades:", error);
    }
  };

  const fetchAplicacoesUnidade = async (idUnidade) => {
    try {
      const response = await getUnidadesById(idUnidade);
      if (response && response.status === 200) {
        const aplicacoes = response.data.unidade.aplicacoes;
        setAplicacoesListagem(aplicacoes);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter aplicações da unidade:", error);
    }
  };

  const fetchPlanosManutencao = async () => {
    try {
      const response = await getPlanosManutencao();

      if (response) {
        const planosManutencaoAtivos = response.data.PlanosManutencao.filter(
          (planoManutencao) => planoManutencao.deleted_at == null
        );
        setPlanosManutencaoListagem(planosManutencaoAtivos);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter a listagem de planos de manutenção:", error);
    }
  };

  const fetchTiposManutencao = async () => {
    try {
      const response = await getTipoManutencao();
      if (response) {
        const tiposManutencaoAtivos = response.data.TiposManutencao.filter(
          (tipoManutencao) => tipoManutencao.deleted_at == null
        );
        setTiposManutencaoListagem(tiposManutencaoAtivos);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter a listagem de tipos de manutenção:", error);
    }
  };

  const fetchPessoas = async () => {
    try {
      const response = await getPessoas();
      if (response) {
        const pessoasAtivas = response.data.pessoas.filter(
          (pessoa) => pessoa.deleted_at == null
        );
        setPessoasListagem(pessoasAtivas);
        setLoading(false);
      } else {
        console.error("A resposta da API não é uma array:");
      }
    } catch (error) {
      console.error("Erro ao obter a listagem de pessoas:", error);
    }
  };

  useEffect(() => {
    if (dadosSolicitacao) {
      fetchDadosSolicitacao();
    }

    if (idOrdem) {
      fetchOrdem();
      fetchAplicacoesUnidade(idUnidade);
    }

    fetchEmpresas();
    fetchUnidades();
    fetchTiposManutencao();
    fetchPlanosManutencao();
    fetchPessoas();
    const interval = setInterval(()=>{
      fetchTiposManutencao();
      fetchPlanosManutencao();
      fetchPessoas();
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [idOrdem, dadosSolicitacao]);

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const validarInputs = () => {
    if (
      !solicitacaoOrdem ||
      !id_unidade ||
      !id_aplicacao ||
      !previsao_inicio ||
      !previsao_termino ||
      !id_pessoa ||
      !id_tipo_manutencao
    ) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Solicitação, Unidade, Aplicação, Tipo de Manutenção, Previsão de Início, Previsão de Término e Solicitante é obrigatório.",
      });
      return false;
    }

    if (previsao_termino < previsao_inicio) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "A data de previsão de início deve ser anterior a data de previsão de término.",
      });

      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    const idSolicitacao = body.id_solicitacao_servico
      ? body.id_solicitacao_servico
      : null;
    try {
      const response = await postOrdem(body, idSolicitacao);
      if (response && response.status === 200) {
        regret();
      }
    } catch (error) {
      console.log(error);
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await updateOrdem(idOrdem, body);
      if (response && response.status === 200) {
        regret();
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar os dados:", error);
        handleOpenModal(
          "Erro ao atualizar os dados",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        solicitacao: solicitacaoOrdem,
        id_unidade,
        id_aplicacao,
        id_tipo_manutencao,
        id_plano_manutencao,
        id_solicitacao_servico,
        id_pessoa,
        informacoes_sistema: informacoesSistema,
        previsao_inicio,
        previsao_termino,
        situacao: "0",
        anexo,
        id_user_gerou: localStorage.getItem("userId"),
      };

      if (idOrdem) {
        delete body.id_user_gerou;
        anexo !== anexoAnterior ? (body.anexo = anexo) : delete body.anexo;
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleSolicitacao = (e) => {
    const value = e.target.value;
    if (value.length <= 255) {
      setSolicitacaoOrdem(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O campo Solicitação não pode ultrapassar 255 caracteres"
      );
    }
  };

  const handleAplicacao = (idAplicacao) => {
    if (idAplicacao) {
      Swal.fire({
        title: "Consultando a data de garantia da aplicação...",
        didOpen: async () => {
          Swal.showLoading();
          try {
            const response = await getApplicationsById(idAplicacao);
            if (response.data.Aplicacao.data_garantia >= getDate()) {
              Swal.fire({
                icon: "warning",
                title: "Cuidado!",
                text: "A aplicação selecionada está dentro do prazo de garantia. Serviços com esta aplicação podem resultar na perda da garantia.",
              });
              setInformacoesSistema(
                "O usuário que gerou esta ordem de serviço foi alertado de que a aplicação selecionada estava dentro do prazo de garantia."
              );
            } else {
              Swal.fire({
                icon: "success",
                title: "Aplicação fora do prazo de garantia",
                text: "Serviços com esta aplicação não resultarão na perda de sua garantia.",
              });
              setInformacoesSistema(null);
            }
          } catch (error) {
            return Swal.fire({
              icon: "error",
              title: "Erro interno",
              text: "Ocorreu um erro dentro do servidor. Tente novamente mais tarde.",
            });
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    } else {
      return;
    }
  };

  const handleAplicacoesUnidade = async (idUnidade) => {
    if (idUnidade === "") {
      setIdUnidade("");
      setAplicacoesListagem([]);
      return;
    } else {
      try {
        const response = await getUnidadesById(idUnidade);
        const arrayAplicacoesUnidade = response.data.unidade.aplicacoes;

        if (
          Array.isArray(arrayAplicacoesUnidade) &&
          arrayAplicacoesUnidade.length > 0
        ) {
          setAplicacoesListagem(arrayAplicacoesUnidade);
        } else {
          setAplicacoesListagem([]);
          return Swal.fire({
            icon: "warning",
            title: "Oops!",
            text: "Essa unidade ainda não tem aplicações cadastradas. Cadastre uma ou selecione outra unidade.",
          });
        }
      } catch (error) {
        console.error(error);
        return Swal.fire({
          icon: "error",
          title: "Erro ao carregar as aplicações da unidade selecionada.",
          text: "Não foi possível carregar as aplicações da unidade selecionada. Tente novamente.",
        });
      }
    }
  };

  const handleDeleteImage = () => {
    setAnexo(null);
    document.getElementById("formAnexo").value = null;
  };

  const handlePrevisaoInicio = (e) => {
    return setPrevisaoInicio(e.replace(/T/g, " ") + ":00");
  };

  const handlePrevisaoTermino = (e) => {
    return setPrevisaoTermino(e.replace(/T/g, " ") + ":00");
  };

  const handleUnidades = (idEmpresa) => {
    //console.log(idEmpresa);
    if (idEmpresa === "") {
      setIdUnidade("");
      return;
    }

    const unidadesEmpresaSelecionada = unidadesBackup.filter(
      (unidade) => unidade.id_empresa.toString() === idEmpresa.toString()
    );

    if (unidadesEmpresaSelecionada.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nenhuma unidade encontrada",
        text: "A empresa selecionada não tem nenhuma unidade cadastrada.",
      });
    }

    setUnidadesListagem(unidadesEmpresaSelecionada);
  };

  useEffect(() => {
    if (!isLoading) {
      handleUnidades(id_empresa);
    }
  }, [id_empresa]);

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === "Enter" && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus =
        nextFieldRef.current.inputRef || nextFieldRef.current;

      if (typeof elementToFocus.focus === "function") {
        elementToFocus.focus();
      } else {
        console.warn("O elemento de input não tem o método focus.");
      }
    }
  };
  const navigate = useNavigate()

  const regret = () => {
    navigate('/ordens-servico');
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Ordem de Serviço" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form className="mt-4">
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formEmpresa">
                  <Form.Label>Empresa:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    value={id_empresa}
                    onChange={(e) => {
                      setIdEmpresa(e.target.value);
                    }}
                    ref={inputRefs.Empresa}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Unidade)}
                  >
                    <option value="">Selecione</option>
                    {empresasListagem.map((empresa) => (
                      <option key={empresa.id} value={empresa.id}>
                        {empresa.nome}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={4} className="mb-3">
                <Form.Group controlId="formUnidade">
                  <Form.Label>Unidade:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    value={id_unidade}
                    disabled={!id_empresa}
                    onChange={(e) => {
                      setIdUnidade(e.target.value);
                      handleAplicacoesUnidade(e.target.value);
                    }}
                    ref={inputRefs.Unidade}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Aplicacao)}
                  >
                    <option value="">Selecione</option>
                    {unidadesListagem.map((unidade) => (
                      <option key={unidade.id} value={unidade.id}>
                        {unidade.nome}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>

              <Col md={4} className="mb-3">
                <Form.Group controlId="formAplicacao">
                  <Form.Label>Aplicação:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    disabled={id_unidade === "" ? true : false}
                    value={id_aplicacao}
                    onChange={(e) => {
                      setIdAplicacao(e.target.value);
                      handleAplicacao(e.target.value);
                    }}
                    ref={inputRefs.Aplicacao}
                    onKeyDown={(e) =>
                      handleKeyDown(e, inputRefs.tipoManutencao)
                    }
                  >
                    <option value="">Selecione</option>
                    {aplicacoesListagem.map((aplicacao) => (
                      <option key={aplicacao.id} value={aplicacao.id}>
                        {aplicacao.descricao}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formTipoManutencao">
                  <Form.Label>Tipo de Manutenção:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    value={id_tipo_manutencao}
                    onChange={(e) => setIdTipoManutencao(e.target.value)}
                    ref={inputRefs.tipoManutencao}
                    onKeyDown={(e) =>
                      handleKeyDown(e, inputRefs.planosManutencao)
                    }
                  >
                    <option value="">Selecione</option>
                    {tiposManutencaoListagem.map((tipoManutencao) => (
                      <option key={tipoManutencao.id} value={tipoManutencao.id}>
                        {tipoManutencao.descricao}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formTipoManutencao">
                  <Form.Label>Plano de Manutenção:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    value={id_plano_manutencao}
                    onChange={(e) => setIdPlanoManutencao(e.target.value)}
                    ref={inputRefs.planosManutencao}
                    onKeyDown={(e) =>
                      handleKeyDown(e, inputRefs.previsaoInicio)
                    }
                  >
                    <option value="">Selecione</option>
                    {planosManutencaoListagem.map((planoManutencao) => (
                      <option
                        key={planoManutencao.id}
                        value={planoManutencao.id}
                      >
                        {planoManutencao.descricao}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formPessoa">
                  <Form.Label>Solicitante:</Form.Label>
                  <Form.Control
                    as="select"
                    placeholder="Selecione"
                    value={id_pessoa}
                    onChange={(e) => setIdPessoa(e.target.value)}
                    disabled={solicitante ? true : false}
                  >
                    <option value="">Selecione</option>
                    {pessoasListagem.map((pessoa) => (
                      <option key={pessoa.id} value={pessoa.id}>
                        {id_solicitacao_servico ? solicitante : pessoa.nome}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formPrevisaoInicio">
                  <Form.Label>Previsão de Início:</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={previsao_inicio}
                    onChange={(e) => handlePrevisaoInicio(e.target.value)}
                    ref={inputRefs.previsaoInicio}
                    onKeyDown={(e) =>
                      handleKeyDown(e, inputRefs.previsaoTermino)
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formPrevisaoTermino">
                  <Form.Label>Previsão de Término:</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    value={previsao_termino}
                    onChange={(e) => handlePrevisaoTermino(e.target.value)}
                    ref={inputRefs.previsaoTermino}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group>
                  <Form.Label>Anexo:</Form.Label>
                  <Form.Control
                    id="formAnexo"
                    type="file"
                    accept="image/png,.jpg,.jpeg"
                    value={anexo?.fileName}
                    onChange={(e) => {
                      setAnexo(e.target.files[0]);
                      //console.log(e.target.files[0]);
                    }}
                    // onChange={(e) => setAnexo(e.target.files[0])}
                  />
                  {anexo ? (
                    <Preview anexo={anexo} handleDelete={handleDeleteImage} />
                  ) : null}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="mb-3">
                <Form.Group controlId="formSolicitacao">
                  <Form.Label>Solicitação:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Descreva a solicitação"
                    value={solicitacaoOrdem}
                    onChange={handleSolicitacao}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};
export default OrdensServicoRegister;
